import { useAuthToken } from '@features/authentication';
import { useSelectedClipMediaResolver } from '@features/Clip/hooks/useSelectedClipMediaResolver';
import { useSelectedClipTracks } from '@features/Clip/hooks/useSelectedClipTracks';
import { useMemo } from 'react';

export const useMedia = () => {
    const { data: mediaRaw, isLoading: isMediaLoading } =
        useSelectedClipMediaResolver('PROXY', 'HIGH');
    const { data: tracksRaw, isLoading: isTracksLoading } =
        useSelectedClipTracks('STITCH', 'LOW');
    const token = useAuthToken();

    const media = useMemo(() => mediaRaw, [mediaRaw]);
    const tracks = useMemo(() => tracksRaw, [tracksRaw]);
    const src = useMemo(() => {
        if (!media.href || !token) return '';
        const url = new URL(`${media.href}/data`);
        url.searchParams.set('access_token', token);
        return url.toString();
    }, [media.href, token]);

    return {
        src,
        media,
        tracks,
        isLoading: isMediaLoading || isTracksLoading,
    };
};
